'use client'

import { styled } from 'styled-components'

import { Breakpoints, Colors, Shadows } from '@b-stock/fe-core/design-system'

export const SearchDropdownWrapper = styled.div<{
  $isOpen: boolean
}>`
  position: absolute;
  top: calc(100% + 0.25rem);
  left: 0.75rem;
  right: 2.75rem;
  z-index: 20;
  display: ${({ $isOpen }) => ($isOpen ? 'block' : 'none')};
  pointer-events: auto;

  /* Stay absolutely positioned at every width: viewport-fixed positioning
     detaches the panel from the field it belongs to, so it lands on top of
     the input wherever that field is not near the top of the viewport. */
  @media ${Breakpoints.max.small} {
    left: 0.5rem;
    right: 0.5rem;
  }
`

export const SearchDropdownContainer = styled.div`
  background: ${Colors.Semantic.Neutral.white};
  background-color: ${Colors.Semantic.Neutral.white};
  border: none;
  border-radius: 0.25rem;
  max-height: 26rem;
  overflow-y: auto;
  ${Shadows.Popovers}
`

export const SearchDropdownItem = styled.button<{
  $isSelected: boolean
}>`
  width: 100%;
  text-align: left;
  border: none;
  background: ${({ $isSelected }) =>
    $isSelected
      ? Colors.Semantic.Neutral.light_grey
      : Colors.Semantic.Neutral.white};
  color: ${Colors.Semantic.Neutral.black};
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background: ${Colors.Semantic.Neutral.light_grey};
  }

  &:last-of-type {
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
  }
`
